import { formatBigNumber } from "@utils/formatBigNumber";

export const formatNumberDecimals = (num: number) => {
  // 如果num为0，则返回0
  // 价格>=$1,显示的小数点后2位，价格<$1，显示到小数点后4位
  const decimalsCondition = num >= 1 ? 2 : 4;

  // 先截取到指定小数位数，然后使用formatNumber格式化

  return formatBigNumber(num, {
    precision: decimalsCondition,
    needFormat: true,
    trimZeros: true,
  });
};
